module.exports = __webpack_public_path__ + "img/ovkasten_ls.fd8e2005.png";